import { MMKV } from 'react-native-mmkv'

export const storageMMKV = new MMKV()
